/* eslint-disable react/no-unknown-property */
import { Form, FormHandlers, FormProps } from '@doveit/bricks';
import React from 'react';
import { GarageType } from '../../../../domain/types/garageType';
import { asSelectOptions } from '../../../../select-options/utils/asSelectOptions';
import { garageTypeLabels } from '../../../../labels/garageTypeLabels';
import upsertPropertyGarageValidationSchema from './UpsertPropertyGarageForm.schema';

export interface UpsertPropertyGarageFormModel {
  size: string,
  floor: string,
  type: GarageType | '',
  adjacent: boolean,
}

export interface UpsertPropertyGarageFormProps {
  initialValues?: Partial<UpsertPropertyGarageFormModel>;
  disabled?: boolean;
  innerRef?: React.MutableRefObject<FormHandlers>,
  loading?: FormProps<UpsertPropertyGarageFormModel>['loading'],
  onSubmit: FormProps<UpsertPropertyGarageFormModel>['onSubmit'],
}

const UPSERT_PROPERTY_GARAGE_FORM_DEFAULT_VALUES: UpsertPropertyGarageFormModel = {
  size: '',
  adjacent: false,
  type: '',
  floor: '',
};

const UpsertPropertyGarageForm: React.FC<UpsertPropertyGarageFormProps> = ({
  initialValues = {},
  ...rest
}) => {
  const mergedInitialValues: UpsertPropertyGarageFormModel = {
    ...UPSERT_PROPERTY_GARAGE_FORM_DEFAULT_VALUES,
    ...initialValues,
  };

  const [selectedType, setSelectedType] = React.useState(mergedInitialValues.type);

  return (
    <Form
      initialValues={mergedInitialValues}
      validationSchema={upsertPropertyGarageValidationSchema(selectedType)}
      {...rest}
    >
      {({ values, setFieldValue }) => {
        const handleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
          const type = e.target.value as GarageType;

          setSelectedType(type);

          if (type !== GarageType.BOX) {
            setFieldValue('floor', '0');
          }
        };

        return (
          <>
            <Form.Item size={{ XS: 1, MD: values.type === GarageType.BOX ? 2.5 / 10 : 4 / 10 }}>
              <Form.Select
                size="S"
                name="type"
                aria-label="Campo per inserire la tipologia del garage"
                options={asSelectOptions(garageTypeLabels, {
                  value: '',
                  label: 'Seleziona tipologia',
                  disabled: true,
                })}
                onChange={handleTypeChange}
                hasErrorTooltip
              />
            </Form.Item>

            <Form.Item size={{ XS: 1, MD: values.type === GarageType.BOX ? 2 / 10 : 2.5 / 10 }}>
              <Form.Input
                size="S"
                name="size"
                type="number"
                prefixElement="m²"
                aria-label="Campo per inserire la dimensione del garage"
                hasErrorTooltip
                min="0"
              />
            </Form.Item>

            {values.type === GarageType.BOX && (
              <Form.Item size={{ XS: 1, MD: 2.5 / 10 }}>
                <Form.Input
                  size="S"
                  name="floor"
                  type="number"
                  aria-label="Campo per specificare il piano del box"
                  placeholder="Es. -1"
                  prefixElement="Piano"
                  hasErrorTooltip
                />
              </Form.Item>
            )}

            <Form.Item size={{ XS: 1, MD: values.type === GarageType.BOX ? 3 / 10 : 3.5 / 10 }}>
              <Form.CheckboxButton
                size="S"
                name="adjacent"
                text="Di pertinenza"
                aria-label="Casella per indicare se un garage è di pertinenza dell'immobile"
              />
            </Form.Item>
          </>
        );
      }}
    </Form>
  );
};

export default UpsertPropertyGarageForm;
